import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", { class: "text-body-1" }, "Шаг 1. Укажите адрес своей электронной почты и код регистрации", -1)

import { useWatcherSavedRef } from '../../../helpers'
import { useVuelidate } from '@vuelidate/core'
import { required, email, helpers } from '@vuelidate/validators'
import { VPasswordField } from '../../../components'
import { CheckKeyOpts } from './interfaces'


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckRegistrationKeyForm',
  props: {
    defaultOpts: {},
    loading: { type: Boolean }
  },
  emits: ["submit"],
  setup(__props: any, { emit }) {

const props = __props;





const rules = {
  email: {
    required: helpers.withMessage('Email не может быть пустым', required),
    email: helpers.withMessage('Некорректный Email', email),
  },
  registrationKey: {
    required: helpers.withMessage('Код регистрации не может быть пустым', required),
  },
}

const opts = useWatcherSavedRef<CheckKeyOpts>('optsForCheckKey', {
  email: '',
  registrationKey: '',
  ...props.defaultOpts,
})

const validator = useVuelidate(rules, opts)

const submit = async () => {
  const valid = await validator.value.$validate()

  if (valid) emit('submit', opts.value)
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(_component_v_form, {
    disabled: _ctx.loading,
    onSubmit: _withModifiers(submit, ["prevent"])
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field, {
                modelValue: _unref(opts).email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(opts).email) = $event)),
                label: "Email*",
                "error-messages": _unref(validator).email.$errors.map(e => e.$message).join(', ')
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(_unref(VPasswordField), {
                modelValue: _unref(opts).registrationKey,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(opts).registrationKey) = $event)),
                label: "Код регистрации*",
                "error-messages": _unref(validator).registrationKey.$errors.map(e => e.$message).join(', ')
              }, null, 8, ["modelValue", "error-messages"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, { justify: "end" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "auto" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                type: "submit",
                color: "primary",
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Далее ")
                ]),
                _: 1
              }, 8, ["loading"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["disabled", "onSubmit"]))
}
}

})